import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/arrow-alt-circle-down': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256S145.5 56 256 56 456 145.5 456 256 366.5 456 256 456zM224 140V256H157C146.3 256 141 268.9 148.5 276.5L247.5 375.5C252.2 380.2 259.8 380.2 264.5 375.5L363.5 276.5C371.1 268.9 365.7 256 355 256H288V140C288 133.4 282.6 128 276 128H236C229.4 128 224 133.4 224 140z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/arrow-alt-circle-down.js
// module id = HQ83
// module chunks = 144